export default {
  install(Vue, options) {
    if (FONTAWESOME.ENV !== 'production') {
      Vue.component('dashboard', () => import('./Dashboard'))
      Vue.component('subscription-dashboard', () => import('./SubscriptionDashboard'))
      Vue.component('permits-dashboard', () => import('./PermitsDashboard'))
      Vue.component('usage-dashboard', () => import('./UsageDashboard'))
    } else {
      Vue.component('dashboard', {})
      Vue.component('subscription-dashboard', {})
      Vue.component('permits-dashboard', {})
      Vue.component('usage-dashboard', {})
    }
  }
}
